import {
  DELETE_VIRTUAL_OPERATOR_MESSAGE_FAILURE,
  DELETE_VIRTUAL_OPERATOR_MESSAGE_REQUEST,
  DELETE_VIRTUAL_OPERATOR_MESSAGE_SUCCESS,
  FETCH_ENTERPRISE_DATA_FAILURE,
  FETCH_ENTERPRISE_DATA_REQUEST,
  FETCH_ENTERPRISE_DATA_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_FAILURE,
  FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_FAILURE,
  FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_FAILURE,
  FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_COSTS_FAILURE,
  FETCH_VIRTUAL_OPERATOR_COSTS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_COSTS_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_MESSAGES_FAILURE,
  FETCH_VIRTUAL_OPERATOR_MESSAGES_REQUEST,
  FETCH_VIRTUAL_OPERATOR_MESSAGES_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_MONITORING_FAILURE,
  FETCH_VIRTUAL_OPERATOR_MONITORING_REQUEST,
  FETCH_VIRTUAL_OPERATOR_MONITORING_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_SETTINGS_FAILURE,
  FETCH_VIRTUAL_OPERATOR_SETTINGS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_SETTINGS_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_STATISTICS_FAILURE,
  FETCH_VIRTUAL_OPERATOR_STATISTICS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_STATISTICS_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_USERS_FAILURE,
  FETCH_VIRTUAL_OPERATOR_USERS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_USERS_SUCCESS,
  SAVE_ENTERPRISE_FESTIVITIES_FAILURE,
  SAVE_ENTERPRISE_FESTIVITIES_REQUEST,
  SAVE_ENTERPRISE_FESTIVITIES_SUCCESS,
  SAVE_ENTERPRISE_INFO_FAILURE,
  SAVE_ENTERPRISE_INFO_REQUEST,
  SAVE_ENTERPRISE_INFO_SUCCESS,
  SAVE_ENTERPRISE_MESSAGE_FAILURE,
  SAVE_ENTERPRISE_MESSAGE_REQUEST,
  SAVE_ENTERPRISE_MESSAGE_SUCCESS,
  SAVE_OPENING_FAILURE,
  SAVE_OPENING_REQUEST,
  SAVE_OPENING_SUCCESS,
  SAVE_VIRTUAL_OPERATOR_MESSAGE_FAILURE,
  SAVE_VIRTUAL_OPERATOR_MESSAGE_REQUEST,
  SAVE_VIRTUAL_OPERATOR_MESSAGE_SUCCESS,
  SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_FAILURE,
  SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_REQUEST,
  SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_SUCCESS,
  SAVE_VIRTUAL_OPERATOR_OFFICE_FAILURE,
  SAVE_VIRTUAL_OPERATOR_OFFICE_REQUEST,
  SAVE_VIRTUAL_OPERATOR_OFFICE_SUCCESS,
  SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_FAILURE,
  SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_REQUEST,
  SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_SUCCESS,
  SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_FAILURE,
  SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_REQUEST,
  SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_SUCCESS,
  SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_FAILURE,
  SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_REQUEST,
  SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_SUCCESS,
  SAVE_VIRTUAL_OPERATOR_USER_FAILURE,
  SAVE_VIRTUAL_OPERATOR_USER_REQUEST,
  SAVE_VIRTUAL_OPERATOR_USER_SUCCESS,
  SET_VIRTUAL_OPERATOR_STATISTICS_FILTER,
} from './types';

export const fetchEnterpriseDataRequest = () => ({
  type: FETCH_ENTERPRISE_DATA_REQUEST,
});
export const fetchEnterpriseDataSuccess = (data) => ({
  type: FETCH_ENTERPRISE_DATA_SUCCESS,
  data,
});
export const fetchEnterpriseDataFailure = (error) => ({
  type: FETCH_ENTERPRISE_DATA_FAILURE,
  error,
});
export const saveEnterpriseMessageRequest = (data) => ({
  type: SAVE_ENTERPRISE_MESSAGE_REQUEST,
  data,
});
export const saveEnterpriseMessageSuccess = (data) => ({
  type: SAVE_ENTERPRISE_MESSAGE_SUCCESS,
  data,
});
export const saveEnterpriseMessageFailure = (error) => ({
  type: SAVE_ENTERPRISE_MESSAGE_FAILURE,
  error,
});
export const saveEnterpriseFestivitiesRequest = (data) => ({
  type: SAVE_ENTERPRISE_FESTIVITIES_REQUEST,
  data,
});
export const saveEnterpriseFestivitiesSuccess = (data) => ({
  type: SAVE_ENTERPRISE_FESTIVITIES_SUCCESS,
  data,
});
export const saveEnterpriseFestivitiesFailure = (error) => ({
  type: SAVE_ENTERPRISE_FESTIVITIES_FAILURE,
  error,
});
export const saveEnterpriseInfoRequest = (data) => ({
  type: SAVE_ENTERPRISE_INFO_REQUEST,
  data,
});
export const saveEnterpriseInfoSuccess = (data) => ({
  type: SAVE_ENTERPRISE_INFO_SUCCESS,
  data,
});
export const saveEnterpriseInfoFailure = (error) => ({
  type: SAVE_ENTERPRISE_INFO_FAILURE,
  error,
});
export const saveOpeningRequest = (data) => ({
  type: SAVE_OPENING_REQUEST,
  data,
});
export const saveOpeningSuccess = (data) => ({
  type: SAVE_OPENING_SUCCESS,
  data,
});
export const saveOpeningFailure = (error) => ({
  type: SAVE_OPENING_FAILURE,
  error,
});
export const fetchVirtualOperatorUsersRequest = (params) => ({
  type: FETCH_VIRTUAL_OPERATOR_USERS_REQUEST,
  params,
});
export const fetchVirtualOperatorUsersSuccess = (data) => ({
  type: FETCH_VIRTUAL_OPERATOR_USERS_SUCCESS,
  data,
});
export const fetchVirtualOperatorUsersFailure = (error) => ({
  type: FETCH_VIRTUAL_OPERATOR_USERS_FAILURE,
  error,
});
export const saveVirtualOperatorUserRequest = (data) => ({
  type: SAVE_VIRTUAL_OPERATOR_USER_REQUEST,
  data,
});
export const saveVirtualOperatorUserSuccess = (data) => ({
  type: SAVE_VIRTUAL_OPERATOR_USER_SUCCESS,
  data,
});
export const saveVirtualOperatorUserFailure = (error) => ({
  type: SAVE_VIRTUAL_OPERATOR_USER_FAILURE,
  error,
});
export const saveVirtualOperatorOfficeRequest = (data) => ({
  type: SAVE_VIRTUAL_OPERATOR_OFFICE_REQUEST,
  data,
});
export const saveVirtualOperatorOfficeSuccess = (data) => ({
  type: SAVE_VIRTUAL_OPERATOR_OFFICE_SUCCESS,
  data,
});
export const saveVirtualOperatorOfficeFailure = (error) => ({
  type: SAVE_VIRTUAL_OPERATOR_OFFICE_FAILURE,
  error,
});
export const fetchVirtualOperatorMessagesRequest = (params) => ({
  type: FETCH_VIRTUAL_OPERATOR_MESSAGES_REQUEST,
  params,
});
export const fetchVirtualOperatorMessagesSuccess = (data) => ({
  type: FETCH_VIRTUAL_OPERATOR_MESSAGES_SUCCESS,
  data,
});
export const fetchVirtualOperatorMessagesFailure = (error) => ({
  type: FETCH_VIRTUAL_OPERATOR_MESSAGES_FAILURE,
  error,
});
export const saveVirtualOperatorMessageRequest = (data) => ({
  type: SAVE_VIRTUAL_OPERATOR_MESSAGE_REQUEST,
  data,
});
export const saveVirtualOperatorMessageSuccess = (data) => ({
  type: SAVE_VIRTUAL_OPERATOR_MESSAGE_SUCCESS,
  data,
});
export const saveVirtualOperatorMessageFailure = (error) => ({
  type: SAVE_VIRTUAL_OPERATOR_MESSAGE_FAILURE,
  error,
});
export const deleteVirtualOperatorMessageRequest = (id) => ({
  type: DELETE_VIRTUAL_OPERATOR_MESSAGE_REQUEST,
  id,
});
export const deleteVirtualOperatorMessageSuccess = (id) => ({
  type: DELETE_VIRTUAL_OPERATOR_MESSAGE_SUCCESS,
  id,
});
export const deleteVirtualOperatorMessageFailure = (error) => ({
  type: DELETE_VIRTUAL_OPERATOR_MESSAGE_FAILURE,
  error,
});
export const fetchVirtualOperatorSettingsRequest = () => ({
  type: FETCH_VIRTUAL_OPERATOR_SETTINGS_REQUEST,
});
export const fetchVirtualOperatorSettingsSuccess = (data) => ({
  type: FETCH_VIRTUAL_OPERATOR_SETTINGS_SUCCESS,
  data,
});
export const fetchVirtualOperatorSettingsFailure = (error) => ({
  type: FETCH_VIRTUAL_OPERATOR_SETTINGS_FAILURE,
  error,
});
export const saveVirtualOperatorSettingsFestivitiesRequest = (data) => ({
  type: SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_REQUEST,
  data,
});
export const saveVirtualOperatorSettingsFestivitiesSuccess = (data) => ({
  type: SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_SUCCESS,
  data,
});
export const saveVirtualOperatorSettingsFestivitiesFailure = (error) => ({
  type: SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_FAILURE,
  error,
});
export const saveVirtualOperatorSettingsClosingRequest = (data) => ({
  type: SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_REQUEST,
  data,
});
export const saveVirtualOperatorSettingsClosingSuccess = (data) => ({
  type: SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_SUCCESS,
  data,
});
export const saveVirtualOperatorSettingsClosingFailure = (error) => ({
  type: SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_FAILURE,
  error,
});
export const fetchVirtualOperatorStatisticsRequest = (params) => ({
  type: FETCH_VIRTUAL_OPERATOR_STATISTICS_REQUEST,
  params,
});
export const fetchVirtualOperatorStatisticsSuccess = (data) => ({
  type: FETCH_VIRTUAL_OPERATOR_STATISTICS_SUCCESS,
  data,
});
export const fetchVirtualOperatorStatisticsFailure = (error) => ({
  type: FETCH_VIRTUAL_OPERATOR_STATISTICS_FAILURE,
  error,
});
export const fetchVirtualOperatorChatDetailsRequest = (params) => ({
  type: FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_REQUEST,
  params,
});
export const fetchVirtualOperatorChatDetailsSuccess = (data) => ({
  type: FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_SUCCESS,
  data,
});
export const fetchVirtualOperatorChatDetailsFailure = (error) => ({
  type: FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_FAILURE,
  error,
});
export const setVirtualOperatorStatisticsFilter = (filter) => ({
  type: SET_VIRTUAL_OPERATOR_STATISTICS_FILTER,
  filter,
});
export const fetchVirtualOperatorMonitoringRequest = (params) => ({
  type: FETCH_VIRTUAL_OPERATOR_MONITORING_REQUEST,
  params,
});
export const fetchVirtualOperatorMonitoringSuccess = (data) => ({
  type: FETCH_VIRTUAL_OPERATOR_MONITORING_SUCCESS,
  data,
});
export const fetchVirtualOperatorMonitoringFailure = (error) => ({
  type: FETCH_VIRTUAL_OPERATOR_MONITORING_FAILURE,
  error,
});
export const fetchVirtualOperatorCostsRequest = (params) => ({
  type: FETCH_VIRTUAL_OPERATOR_COSTS_REQUEST,
  params,
});
export const fetchVirtualOperatorCostsSuccess = (data) => ({
  type: FETCH_VIRTUAL_OPERATOR_COSTS_SUCCESS,
  data,
});
export const fetchVirtualOperatorCostsFailure = (error) => ({
  type: FETCH_VIRTUAL_OPERATOR_COSTS_FAILURE,
  error,
});
export const fetchVirtualOperatorAmbrogioCostsRequest = (params) => ({
  type: FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_REQUEST,
  params,
});
export const fetchVirtualOperatorAmbrogioCostsSuccess = (data) => ({
  type: FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_SUCCESS,
  data,
});
export const fetchVirtualOperatorAmbrogioCostsFailure = (error) => ({
  type: FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_FAILURE,
  error,
});
export const fetchVirtualOperatorAmbrogioPbxsRequest = () => ({
  type: FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_REQUEST,
});
export const fetchVirtualOperatorAmbrogioPbxsSuccess = (data) => ({
  type: FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_SUCCESS,
  data,
});
export const fetchVirtualOperatorAmbrogioPbxsFailure = (error) => ({
  type: FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_FAILURE,
  error,
});
export const saveVirtualOperatorNoCreditRuleRequest = (params) => ({
  type: SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_REQUEST,
  params,
});
export const saveVirtualOperatorNoCreditRuleSuccess = () => ({
  type: SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_SUCCESS,
});
export const saveVirtualOperatorNoCreditRuleFailure = (error) => ({
  type: SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_FAILURE,
  error,
});
export const saveVirtualOperatorTicketSettingsRequest = (params) => ({
  type: SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_REQUEST,
  params,
});
export const saveVirtualOperatorTicketSettingsSuccess = () => ({
  type: SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_SUCCESS,
});
export const saveVirtualOperatorTicketSettingsFailure = (error) => ({
  type: SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_FAILURE,
  error,
});